import React from 'react';
import { Typography, Box, Container, Paper, Divider } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

function ApplicationDeclined() {
  return (
    <Container maxWidth="md">
      <Box sx={{ my: 4 }}>
        <Paper elevation={3} sx={{ p: 4 }}>
          <Box sx={{ textAlign: 'center', py: 4 }}>
            <CheckCircleOutlineIcon 
              sx={{ 
                fontSize: 80, 
                color: 'primary.main',
                mb: 3
              }} 
            />
            
            <Typography variant="h4" gutterBottom sx={{ fontWeight: 600, color: 'primary.main' }}>
              Thank You for Your Interest
            </Typography>
            
            <Divider sx={{ my: 3 }} />
            
            <Typography variant="body1" sx={{ mt: 3, mb: 3, lineHeight: 1.8 }}>
              We appreciate you taking the time to learn about Evolving Minds. While we're sorry you've decided not to proceed with the application at this time, we understand that timing and fit are important considerations.
            </Typography>
            
            <Typography variant="body1" sx={{ mb: 4, lineHeight: 1.8 }}>
              If you change your mind in the future, please don't hesitate to reach out to us. We wish you all the best in your professional journey.
            </Typography>
            
            <Divider sx={{ my: 3 }} />
            
            <Box sx={{ mt: 4, pt: 2 }}>
              <Typography variant="body2" color="text.secondary">
                If you have any questions, please contact us at{' '}
                <a 
                  href="mailto:info@evolvingminds.co.uk" 
                  style={{ 
                    color: '#2196f3', 
                    textDecoration: 'none',
                    fontWeight: 600
                  }}
                >
                  info@evolvingminds.co.uk
                </a>
              </Typography>
            </Box>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
}

export default ApplicationDeclined;
